import api from './apiClient';

export const scanAPI = {
  scanByQRCode: (qrcode, scannedById, method = 'QR_CODE', location = 'Mobile App') =>
    api.post('/scans/qrcode', { qrcode, scannedById, scanMethod: method, location }),

  scanByTicketId: (ticketId, scannedById, method = 'QR_CODE', location = 'Mobile App') =>
    api.post(`/scans/ticket/${ticketId}`, { scannedById, scanMethod: method, location }),

  getScansByTicket: (ticketId) => api.get(`/scans/ticket/${ticketId}`),
  getScansByEvent: (eventId) => api.get(`/scans/event/${eventId}`),
  getEventScanStats: (eventId) => api.get(`/scans/event/${eventId}/stats`),
  getScansByUser: (userId) => api.get(`/scans/user/${userId}`),
};

export default scanAPI;

